module.exports = __webpack_public_path__ + "img/background.060f8650.png";